var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"loading":_vm.loading},on:{"click":_vm.removeFromChat}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-account-cancel")]),_vm._v(" "+_vm._s(_vm.$t("common.remove"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }